import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import Comments from "../Comments/Comment";
import { Button, Overlay, OverlayTrigger, Popover, Row, Table, Form } from "react-bootstrap";
import emailIcon from "../../../../Assets/Images/Email.svg";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import { compName, month } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import moment from "moment";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { MultiSelect } from "primereact/multiselect";
import Loader from "../../../Loader/Loader";
import filter from "../../../../Assets/Images/Configuration/filter-icon.svg";
import Filter_MonthDowRoomTypeRatePlanChannels from "./Models/Filter_MonthDowRoomTypeRatePlanChannels";
const RNXAnalysis1_Month = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
    topfilterdata,
    topviewoption
}) => {
    const [viewOption, setViewOption] = useState("Graph");

    useEffect(() => {
        if (topviewoption) {
            setViewOption(topviewoption)
        }
    }, [topviewoption]);

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => { setWidgetModal(false); };

    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
        id2: commonService.GenerateGUID(),
        id3: commonService.GenerateGUID(),
        id4: commonService.GenerateGUID(),
    });

    const [filterData, setFilterData] = useState({ year: new Date().getFullYear(), months: [], dow: [], ratecodes: [], roomtypes: [], combinedchannels: [] });

    const [CurrentYearData, setCurrentYearData] = useState([]);

    const [LastYearData, setLastYearData] = useState([]);

    const [FinalData, setFinalData] = useState([]);

    const GetCurrentYearData = async () => {
        setCurrentYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot + API_URL.RNX.RNX_MONTH_WISE_SUMMARY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setCurrentYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const GetLastYearData = async () => {
        setLastYearData([]);
        try {
            let TableResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.RNX.RNX_MONTH_WISE_SUMMARY_STLY,
                    body: {
                        asofdate: para?.asOfDate,
                        propertycode: para?.propertyCode,
                        year: filterData.year,
                        months: filterData.months ? filterData.months.map(item => item.code) : [],
                        daysofweek: filterData.dow ? filterData.dow.map(item => item.code) : [],
                        ratecodes: filterData.ratecodes ? filterData.ratecodes.map(item => item.code) : [],
                        roomtypes: filterData.roomtypes ? filterData.roomtypes.map(item => item.code) : [],
                        channels: filterData.combinedchannels ? filterData.combinedchannels.map(item => item.code) : [],
                    },
                },
                false
            );
            let response = apiResponse(false, TableResponse);
            if (response?.isValidate) {
                setLastYearData(response?.data?.data);
            }
        } catch (error) {

        }
    };

    const [dataLoading, setDataLoading] = useState(false);

    const GetAllData = async () => {
        setDataLoading(true);
        await GetCurrentYearData();
        await GetLastYearData();
        setDataLoading(false);
    };

    useEffect(() => {
        if (api === 0) {
            const monthData = month.map(m => ({
                month: m,
                currentyearroom: 0,
                currentyearadr: 0,
                currentyearrev: 0,
                stlyroom: 0,
                stlyroomdiff: 0,
                stlyrev: 0,
                stlyrevdiff: 0,
                stlyadr: 0,
                stlyadrdiff: 0,
                lastyearroom: 0,
                lastyearroomdiff: 0,
                lastyearrev: 0,
                lastyearrevdiff: 0,
                lastyearadr: 0,
                lastyearadrdiff: 0,
            }));

            const totalRow = {
                month: "Total",
                currentyearroom: 0,
                currentyearadr: 0,
                currentyearrev: 0,
                stlyroom: 0,
                stlyroomdiff: 0,
                stlyrev: 0,
                stlyrevdiff: 0,
                stlyadr: 0,
                stlyadrdiff: 0,
                lastyearroom: 0,
                lastyearroomdiff: 0,
                lastyearrev: 0,
                lastyearrevdiff: 0,
                lastyearadr: 0,
                lastyearadrdiff: 0,
            };

            setFinalData([...monthData, totalRow]);
        } else {
            if (para?.asOfDate) {
                GetAllData();
            }
        }
    }, [para?.asOfDate, filterData]);

    useEffect(() => {
        if (topfilterdata) {
            setFilterData(topfilterdata)
        }
    }, [topfilterdata]);

    useEffect(() => {
        if (!dataLoading) {
            let _FinalData = [];
            const totalRow = {
                month: "Total",
                currentyearroom: 0,
                currentyearadr: 0,
                currentyearrev: 0,
                stlyroom: 0,
                stlyroomdiff: 0,
                stlyrev: 0,
                stlyrevdiff: 0,
                stlyadr: 0,
                stlyadrdiff: 0,
                lastyearroom: 0,
                lastyearroomdiff: 0,
                lastyearrev: 0,
                lastyearrevdiff: 0,
                lastyearadr: 0,
                lastyearadrdiff: 0,
            };

            month.map((m) => {
                //CurrentYearData
                //LastYearData

                let currentyearroom = 0,
                    currentyearrev = 0,
                    currentyearadr = 0,

                    stlyroom = 0,
                    stlyroomdiff = 0,
                    stlyrev = 0,
                    stlyrevdiff = 0,
                    stlyadr = 0,
                    stlyadrdiff = 0,

                    lastyearroom = 0,
                    lastyearroomdiff = 0,
                    lastyearrev = 0,
                    lastyearrevdiff = 0,
                    lastyearadr = 0,
                    lastyearadrdiff = 0;

                let CD = CurrentYearData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (CD && CD.length > 0) {
                    currentyearroom = CD[0].total_roomnights ? parseInt(CD[0].total_roomnights) : 0;
                    currentyearrev = CD[0].total_revenue ? parseInt(CD[0].total_revenue) : 0;
                    currentyearadr = CD[0].adr ? parseInt(CD[0].adr) : 0;

                    stlyroom = CD[0].lastyear_total_roomnights ? parseInt(CD[0].lastyear_total_roomnights) : 0;
                    stlyroomdiff = commonService.GrowthFormula(currentyearroom, stlyroom);

                    stlyrev = CD[0].lastyear_total_revenue ? parseInt(CD[0].lastyear_total_revenue) : 0;
                    stlyrevdiff = commonService.GrowthFormula(currentyearrev, stlyrev);

                    stlyadr = CD[0].lastyear_adr ? parseInt(CD[0].lastyear_adr) : 0;
                    stlyadrdiff = commonService.GrowthFormula(currentyearadr, stlyadr);
                }

                let LD = LastYearData.filter((d) => d.monthname.toUpperCase() === m.substr(0, 3).toUpperCase())

                if (LD && LD.length > 0) {
                    lastyearroom = LD[0].stly_total_roomnights ? parseInt(LD[0].stly_total_roomnights) : 0;
                    lastyearroomdiff = commonService.GrowthFormula(currentyearroom, lastyearroom);

                    lastyearrev = LD[0].stly_total_revenue ? parseInt(LD[0].stly_total_revenue) : 0;
                    lastyearrevdiff = commonService.GrowthFormula(currentyearrev, lastyearrev);

                    lastyearadr = LD[0].stly_adr ? parseInt(LD[0].stly_adr) : 0;
                    lastyearadrdiff = commonService.GrowthFormula(currentyearadr, lastyearadr);
                }

                _FinalData.push({
                    month: m,
                    currentyearroom: currentyearroom,
                    currentyearadr: currentyearadr,
                    currentyearrev: currentyearrev,
                    stlyroom: stlyroom,
                    stlyroomdiff: stlyroomdiff,
                    stlyrev: stlyrev,
                    stlyrevdiff: stlyrevdiff,
                    stlyadr: stlyadr,
                    stlyadrdiff: stlyadrdiff,
                    lastyearroom: lastyearroom,
                    lastyearroomdiff: lastyearroomdiff,
                    lastyearrev: lastyearrev,
                    lastyearrevdiff: lastyearrevdiff,
                    lastyearadr: lastyearadr,
                    lastyearadrdiff: lastyearadrdiff,
                });

                totalRow.currentyearroom += currentyearroom;
                totalRow.currentyearrev += currentyearrev;
                totalRow.currentyearadr = totalRow.currentyearrev !== 0 && totalRow.currentyearroom !== 0 ? parseInt(totalRow.currentyearrev / totalRow.currentyearroom) : 0;

                totalRow.stlyroom += stlyroom;
                totalRow.stlyroomdiff = commonService.GrowthFormula(totalRow.currentyearroom, totalRow.stlyroom);
                totalRow.stlyrev += stlyrev;
                totalRow.stlyrevdiff = commonService.GrowthFormula(totalRow.currentyearrev, totalRow.stlyrev);
                totalRow.stlyadr = totalRow.stlyrev !== 0 && totalRow.stlyroom !== 0 ? parseInt(totalRow.stlyrev / totalRow.stlyroom) : 0;
                totalRow.stlyadrdiff = commonService.GrowthFormula(totalRow.currentyearadr, totalRow.stlyadr);

                totalRow.lastyearroom += lastyearroom;
                totalRow.lastyearroomdiff = commonService.GrowthFormula(totalRow.currentyearroom, totalRow.lastyearroom);
                totalRow.lastyearrev += lastyearrev;
                totalRow.lastyearrevdiff = commonService.GrowthFormula(totalRow.currentyearrev, totalRow.lastyearrev);
                totalRow.lastyearadr = totalRow.lastyearrev !== 0 && totalRow.lastyearroom !== 0 ? parseInt(totalRow.lastyearrev / totalRow.lastyearroom) : 0;
                totalRow.lastyearadrdiff = commonService.GrowthFormula(totalRow.currentyearadr, totalRow.lastyearadr);
            });

            _FinalData.push(totalRow);
            setFinalData(_FinalData);
        }
    }, [dataLoading]);

    let AllWidgetContainer = document.getElementById(
        "RNXAnalysis1_Month"
    );

    if (AllWidgetContainer !== null) {
        let CW = AllWidgetContainer.clientWidth;
        CW = CW - 120;
        CW = Math.round(CW / 3);
        if (CW < 250) {
            CW = 250;
        }
        let Widget = AllWidgetContainer.getElementsByClassName(
            "allTableTogather-widget"
        );
        if (Widget !== null && Widget.length !== 0) {
            for (let i = 0; i < Widget.length; i++) {
                Widget[i].style.width = CW + "px";
            }
        }
    }

    const [DisplayFilter, setDisplayFilter] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const ShowFilter = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setDisplayFilter({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const CloseFilter = (data) => {
        setDisplayFilter({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        setFilterData(data)
    };

    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.id2} .perbackground-rev`
    );

    return (
        <div
            className="widget-container"
            style={{ position: "relative", padding: "0 5px" }}
        >
            {api !== 0 &&  (
                <div className="gap-1 widget-container-menu">

                    {
                        !topfilterdata &&
                        <Button id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Month", "filter", propertyCode)} className="heading-menu-btns" type="button" title="Filter"
                            onClick={(e) => {
                                ShowFilter(e);
                            }}>
                            <img
                                src={filter}
                                alt="Filter"
                            />
                        </Button>
                    }

                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Month", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1 +
                                    "," +
                                    tblids.id2 +
                                    "," +
                                    tblids.id3 +
                                    "," +
                                    tblids.id4,
                                    "Snapshot By Month",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Month", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.annualSummary,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("RNXAnalysis1_Month", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={
                                tblids.id1 +
                                "," +
                                tblids.id2 +
                                "," +
                                tblids.id3 +
                                "," +
                                tblids.id4
                            }
                            onClick={() => {
                                commonService.fnExportInCSV(
                                    tblids.id1 +
                                    "," +
                                    tblids.id2 +
                                    "," +
                                    tblids.id3 +
                                    "," +
                                    tblids.id4,
                                    `${para?.propertyCode}-Annual Summary-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                );
                            }}
                        />
                    </Button>

                    {
                        DisplayFilter.IsDisplay &&
                        <Overlay
                            show={DisplayFilter.IsDisplay}
                            target={DisplayFilter.Target}
                            placement={DisplayFilter.Position}
                        >
                            <Popover
                                id="popover-contained"
                                className="FilterPopover"
                            >
                                <Filter_MonthDowRoomTypeRatePlanChannels show={DisplayFilter.IsDisplay} closeModal={CloseFilter} para={para} dropdownSelectedData={filterData} />
                            </Popover>
                        </Overlay>
                    }

                </div>
            ) }
            <div className="allTableTogatherWrapper" id="RNXAnalysis1_Month">
                <div style={{ display: "flex", gridGap: "10px" }}>
                    <div style={{ width: "120px", flex: "none" }}>
                        <div className="ViewPropertySetupTable monthSelectTable">
                            <div className="stripped__table">
                                <Table id={tblids.id1} responsive>
                                    <thead>
                                        <tr>
                                            <th>

                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Month</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            dataLoading ?
                                                <tr
                                                    style={{
                                                        height: "80px",
                                                        position: "relative",
                                                    }}
                                                >
                                                    <Loader />
                                                </tr>
                                                :
                                                <>
                                                    {month?.map((item, index) => (
                                                        <tr key={item}>
                                                            <td>{item}</td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td className="boldTd">Total</td>
                                                    </tr>
                                                </>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive" style={{ flex: "1" }}>
                        <div
                            className="allTableTogather"
                            style={{ display: "flex", gridGap: "10px" }}
                        >
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id2} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan={3} className={"text-center"}>{filterData.year}</th>
                                                </tr>
                                                <tr>
                                                    <th>ROOMS</th>
                                                    <th className={"text-end"}>ADR</th>
                                                    <th className={"text-end"}>REV</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.month === "Total" ? "boldTd" : ""}`}>{item.currentyearroom}</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.currentyearadr)}</td>
                                                                    <td className={` text-end ${item.month === "Total" ? "boldTd" : "perbackground perbackground-rev"}`} value={item.currentyearrev}>{commonService.formateAmount(item.currentyearrev)}</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id3} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        STLY
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="1">ROOMS</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ROOMS vs STLY">VAR</th>
                                                    <th colSpan="1" className={"text-end"}>ADR</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ADR vs STLY">VAR</th>
                                                    <th colSpan="1" className={"text-end"}>REV</th>
                                                    <th colSpan="1" className="text-center cursor-pointer"  title="Current REV vs STLY">VAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.month === "Total" ? "boldTd" : ""}`}>{item.lastyearroom}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.lastyearroomdiff !== 0 ? item.lastyearroomdiff > 0 ? "greenText" : "redText" : ""}`}>{item.lastyearroomdiff}%
                                                                    </td>

                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.lastyearadr)}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.lastyearadrdiff !== 0 ? item.lastyearadrdiff > 0 ? "greenText" : "redText" : ""}`}>{item.lastyearadrdiff}%</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.lastyearrev)}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.lastyearrevdiff !== 0 ? item.lastyearrevdiff > 0 ? "greenText" : "redText" : ""}`}>{item.lastyearrevdiff}%</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }
                                            </tbody>
                                            
                                        </Table>
                                    </div>
                                </div>
                            </div>
                            <div className="p-0 allTableTogather-widget">
                                <div className="ViewPropertySetupTable">
                                    <div className="stripped__table">
                                        <Table id={tblids.id4} responsive>
                                            <thead>
                                                <tr>
                                                    <th colSpan="6" className={"text-center"}>
                                                        {filterData.year - 1}
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="1">ROOMS</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ROOMS vs Total LY" >VAR</th>
                                                    <th colSpan="1" className={"text-end cursor-pointer"}>ADR</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current ADR vs Total LY" >VAR</th>
                                                    <th colSpan="1" className={"text-end"}>REV</th>
                                                    <th colSpan="1" className="text-center cursor-pointer" title="Current REV vs Total LY" >VAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dataLoading ?
                                                        <tr
                                                            style={{
                                                                height: "80px",
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Loader />
                                                        </tr>
                                                        :
                                                        <>
                                                            {FinalData?.map((item, index) => (
                                                                <tr>
                                                                    <td className={` ${item.month === "Total" ? "boldTd" : ""}`}>{item.stlyroom}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.stlyroomdiff !== 0 ? item.stlyroomdiff > 0 ? "greenText" : "redText" : ""}`}>{item.stlyroomdiff}%</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.stlyadr)}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.stlyadrdiff !== 0 ? item.stlyadrdiff > 0 ? "greenText" : "redText" : ""}`}>{item.stlyadrdiff}%</td>
                                                                    <td className={`text-end ${item.month === "Total" ? "boldTd" : ""}`}>{commonService.formateAmount(item.stlyrev)}</td>
                                                                    <td className={`text-center ${item.month === "Total" ? "boldTd" : ""} ${item.stlyrevdiff !== 0 ? item.stlyrevdiff > 0 ? "greenText" : "redText" : ""}`}>{item.stlyrevdiff}%</td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                }

                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            {api !== 0 && !topfilterdata && (
                <Comments widgetDetails={para} editorId={"editor" + tblids.id1} />
            )}

        </div>
    );
};

export default RNXAnalysis1_Month;
